import { TranslationMap } from '@trimble-gcs/i18n-types';

export function classifierTranslations() {
  return {
    classifiers: {
      aerial: {
        text: $localize`:@@classifier.aerial:Aerial`,
        desc: "Pointcloud classifier for an 'Aerial' scan.",
      },
      rails: {
        text: $localize`:@@classifier.rails:Rails`,
        desc: "Pointcloud classifier for a 'Rails' scan.",
      },
      terrestrial: {
        text: $localize`:@@classifier.terrestrial:Terrestrial`,
        desc: "Pointcloud classifier for a 'Terrestrial' scan.",
      },
    },
  } satisfies TranslationMap;
}
